module.exports = __webpack_public_path__ + "static/media/gmail-icon.62a3f0ae.svg";